import { AttachmentForm } from 'Components/_NewElements/GeneralForms/AttachmentsForm';
import ConfirmationDialog from 'Components/ConfirmationDialog';
import React from 'react';
import { useIntl } from 'react-intl';

const ChangeDialog = ({ dialogOpen, setNewAttachment }: IChangeDialog) => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  const [attachment, setAttachment] = React.useState<File | null>(null);

  const handleTempFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.[0]) {
      setAttachment(e.target.files[0]);
    }
  };

  return (
    <ConfirmationDialog
      open={dialogOpen}
      fullWidth={false}
      text={
        <div style={{ minWidth: '40rem' }}>
          <AttachmentForm
            fm={fm}
            attachmentData={attachment ? [attachment] : []}
            handleFileChange={handleTempFileChange}
            allowedTypes={['.jpg', '.jpeg', '.png']}
            attachmentLimit={1}
          />
        </div>
      }
      cancel={{
        callback: e => {
          e.stopPropagation();
          setNewAttachment(null);
          setAttachment(null);
        },
      }}
      confirm={{
        disabled: !attachment,
        text: 'general.accept',
        callback: async e => {
          attachment && setNewAttachment(attachment);
          setAttachment(null);
        },
      }}
    />
  );
};

interface IChangeDialog {
  dialogOpen: boolean;
  setNewAttachment: (file: File | null) => void;
}

export default ChangeDialog;
